export enum ShipmentSubscribeState {
  SubscribeByDefault = 'subscribe_by_default',
  SubscribeByPMT = 'subscribe_by_pmt',
  UnsubscribeByDefault = 'unsubscribe_by_default',
  UnsubscribeByPMT = 'unsubscribe_by_pmt',
  UnsubscribeByEmail = 'unsubscribe_by_email',
}
